import CryptoJS from 'crypto-js'
export default {
    /**
     * @param {*需要加密的字符串 注：对象转化为json字符串再加密} word
     * @param {*aes加密需要的key值，这个key值后端同学会告诉你} keyStr
     * 两个方法中的第一个参数word是待加密或者解密的字符串，第二个参数keyStr是aes加密需要用到的16位字符串的key。如果想对一个js对象加密，需要先把该对象转成json字符串。
     */
    encrypt(word, keyStr) { // 对称加密
        var key = CryptoJS.enc.Utf8.parse(keyStr)
        var srcs = CryptoJS.enc.Utf8.parse(JSON.stringify(word))
        var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }) // 加密模式为ECB，补码方式为PKCS5Padding（也就是PKCS7）
        return encrypted.toString()
    },
    //非对称加密
    encryptRsa(key) {
        let encryptor = new JSEncrypt() // 新建JSEncrypt对象 
        let publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC6m8p/XgR+fN1RrhehITYNy2lKpIjwb5qtNPSUzY3/Jv5N9cNw+9ESGAmL5z/ZH7KpYeyqgQ9Sa4koQuk4020n+DATJMXznkw01iZARcBuh8tyzlCwKjMZz9ZOX3zko0uJo6BL7LRCB/m9e3INFXnakGz/9EHgNAfmDo3BMxN+ywIDAQAB' //把之前生成的贴进来，实际开发过程中，可以是后台传过来的
        encryptor.setPublicKey(publicKey) // 设置公钥 
        let rsaPassWord = encryptor.encrypt(key) // 对需要加密的数据进行加密 
        return rsaPassWord //得到加密后的数据
    },
    // 对称解密
    decrypt(word, keyStr) {
        var key = CryptoJS.enc.Utf8.parse(keyStr);
        var decrypt = CryptoJS.AES.decrypt(word, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return JSON.parse(decrypt.toString(CryptoJS.enc.Utf8));
    },
    //非对称解密方法
    RSAdecrypt(pas) {
        var privateKey = 'MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAMHR+1RxoZhZokA5Y+Rc67i2QSaT/lIy5wkKkON5CY56j6KJvQuP6HETr7iJeJM0htUlWZJpsE2Xq1bIfhJv5CthSG11q1IP+NMy0I8pIW6GUNLacs8dPvUHvT8n+4Moi2T0gRG5rzRcD+6ZmjeAHFjJhQb2ci3jFryMkO5dQXC3AgMBAAECgYBrcumOSuB3AVn9mNNUCl9zqzY7GNho4WdLj9v6/2LY5gEy7oErI8CMz4kfGLcLhJcrGuWpUYY3vdly5vtdZUJsAjrKW/4GFo8vhd2CCfgK06C1Oxf6PqnDAhH/xlBj1kG9YJFnG6/uRxmddEXILaR6hnyRm2V2CtITWS09Kikh4QJBAPMUxCBxxV0XxdjCRKYxYuOxVp5yq9jjb2LV4Ios5XJZspXQ+YeXWrbZ/Av+AedJT+47rBCIvrvHlIUzj7D1oiUCQQDMHv+AZpocR73rnyHJ3QshWAgPJoQBgPeuDoFAxNIk+fNKboojVMyovAum+0z+gmz5rQPO5EQrkHHSNF9+nvqrAkAr6lSEiAlgCCt2PaKpY8K54BAGEDF7vZsiAAHQ9Mt/HTVmW5q5JF7/KeKfSASQBG6sW5t6YToUMrpiVi5figEBAkEAjfqNu7EiRsN8DfU9Glz/De1ehbNDpIwhO1dpfjSo+wFEwaQLv7GPPVq3PCmWD32G8U/v0yuhYy/wi8bUGY3ZSwJAEn84BQOUu7aOmPNM9QhzMzkOC5QXnrL66YgSkIGsrh6BJImcJ8rXNozA4+MxkWgYkm9QCHqKErwMzzXHncr/nQ=='
        let jse = new JSEncrypt();
        // 私钥
        jse.setPrivateKey(privateKey)
        return jse.decrypt(pas);
    },
    //生成随机数
    RandomNumber(pasLen) {
        var pasArr = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        var password = '';
        var pasArrLen = pasArr.length;
        for (var i = 0; i < pasLen; i++) {
            var x = Math.floor(Math.random() * pasArrLen);
            password += pasArr[x];
        }
        return password;
    },
    //访问接口前对数据加密的公用方法
    /*userParam  字符串拼接*/
    PublicEntryption(userParam) {
        //token token值
        //Page 当前页
        //PageSize 每页默认10条
        //UserType type为1时 参会企业  需要传此参数  传1采购商 2供货商
        let ariginalKey = this.RandomNumber(16); //生成随机得key值
        let EntryptionUserParam = this.encrypt(userParam, ariginalKey); //用随机生成的key值对称机密用户信息
        let encryptRsakey = this.encryptRsa(ariginalKey); //对随机生成的key值进行非对称加密
        let reslutModel = {
            encryptData: EntryptionUserParam,
            key: encryptRsakey
        };
        return encodeURIComponent(JSON.stringify(reslutModel))
    },
    //解密
    PublicDecode(response) {
        let keyParam = response.key; //对解密要用到得key值进行解码
        let dataParam = response.encryptData; //对返回来的数据进行解码
        let key = this.RSAdecrypt(keyParam); //非对称解密 key值
        let data = this.decrypt(dataParam, key); //用得到的key值对返回来数据进行对称解密
        return data
    }

}


// WEBPACK FOOTER //
// ./src/assets/until.js